import {useConfig, useSwitchChain} from 'wagmi';

export const useSwitchToTargetChain = () => {
  const {chains} = useConfig();
  const {switchChain} = useSwitchChain();

  return () => {
    switchChain({chainId: chains[0].id});
  };
};
